<template>
  <div>
    <div class="container-fluid m-0 p-0">
       <div class="row justify-content-center">
        <div class="col-md-2 t-center mt-5 pt-5">
          <img src="@/assets/S+.png" alt="CompTIA S+ Logo" class="img-fluid mb-3"
          />
        </div>
      </div>

      <div class="row bg-white pt-5 pb-5 ms-5 border-bottom">
        <div class="col-md-1 p-0 t-center">Kapitel</div>
        <div class="col-md-2 p-0 t-center">PDF</div>

        <div class="col-md-3 p-0 t-center">Bezeichnung</div>
        <div class="col-md-2 p-0 t-center">Quiz</div>
        <div class="col-md-3 p-0 t-center">Link</div>
      </div>

      <div class="row ms-5" v-for="i in 22" :key="i">
        <div class="col-md-1 p-0 t-center">{{ i }}</div>
        <div class="col-md-2 p-0 t-center">
          <a :href="`/PDF/${$data['PDF' + i]}`" download v-if="$data['PDF' + i]">
            <button class="btn btn-success p-1 m-1" style="min-width: 100px">
              PDF {{ i }}
            </button>
          </a>

          <a
            :href="`/PDF/${$data['PDF' + i + 'a']}`"
            download
            v-if="$data['PDF' + i + 'a']"
          >
            <button class="btn btn-success p-1 m-1" style="min-width: 100px">
              PDF {{ i }}
            </button>
          </a>
        </div>
        <div class="col-md-3 p-0 t-center">
          {{ $data["Titel" + i] }}
        </div>

        <div class="col-md-2 p-0 t-center">
          <a :href="$data['Link' + i]" target="_blank" v-if="$data['Link' + i]">
            <button class="btn btn-primary p-1 m-1" style="min-width: 160px">
              Zum Quiz {{ i }}
            </button>
          </a>
        </div>

        <div class="col-md-4 p-0 t-center">
          {{ $data["Link" + i] }}
        </div>
      </div>
      <h2 class="ps-5 pt-5">Ergänzungen</h2>
      <div class="row ms-5" v-for="i in 30" :key="i">
        <div class="col-md-1 p-0 t-center"></div>
        <div class="col-md-1 p-0 t-center">
          <a
            :href="`/PDF/${$data['PDF_sonstige' + i]}`"
            download
            v-if="$data['PDF_sonstige' + i]"
          >
            <button class="btn btn-secondary p-1 m-1" style="min-width: 100px">
              PDF Sonstige {{ i }}
            </button>
          </a>
        </div>
        <div class="col-md-3 p-0 t-center">
          {{ $data["PDF_sonstige" + i] }}
        </div>
      </div>
      <h2 class="ps-5 pt-5">90 Fragen Quiz</h2>
      <div class="row ms-5" v-for="i in 10" :key="i">
        <div class="col-md-1 p-0 t-center"></div>
        <div class="col-md-2 p-0 t-center">
          <a :href="$data['quiz90_' + i]" target="_blank" v-if="$data['quiz90_' + i]">
            <button class="btn btn-primary p-1 m-1" style="min-width: 160px">
              Zum Quiz {{ i }}
            </button>
          </a>
        </div>
        <div class="col-md-9 p-0 t-center">
          {{ $data["quiz90_" + i] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KapitelfragenQuizPage_S_Plus",

  data() {
    return {
      newSite: null,
      Titel1: "",
      Titel2: "Eingangstest, Wie gut sind Sie vorbereitet?",
      Titel3: "Wo liegt denn das Problem?",
      Titel4: "Rechtliche Grundlagen der Informationssicherheit",
      Titel5: "Verschlüsselungstechnologie",
      Titel6: "Die Geschichte mit der Identität",
      Titel7: "Physische Sicherheit",
      Titel8: "Im Angesicht des Feindes",
      Titel9: "Systemsicherheit realisieren",
      Titel10: "Sicherheit für mobile Systeme",
      Titel11: "Den DAU gibt’s wirklich – und Sie sind schuld",
      Titel12: "Sicherheit für Netzwerke",
      Titel13: "Schwachstellen und Attacken",
      Titel14: "Der sichere Remote-Zugriff",
      Titel15: "Drahtlose Netzwerke sicher gestalten",
      Titel16: "System- und Netzwerküberwachung",
      Titel17: "Brandschutzmauer für das Netzwerk",
      Titel18: "Sicherheit überprüfen und analysieren",
      Titel19: "Wider den Notfall",
      Titel20: "Security-Audit",
      Titel21: "",
      Titel22: "TerminalFix Berlin",
      Link1: "",
      Link2: "https://forms.cloud.microsoft/e/FcEF0eB4pw?origin=lprLink",
      Link3: "https://forms.cloud.microsoft/e/NzgdM0VJ4a?origin=lprLink",
      Link4: "https://forms.cloud.microsoft/e/KrX6eivN3W?origin=lprLink",
      Link5: "https://forms.cloud.microsoft/e/i1k8HDReuz?origin=lprLink",
      Link6: "https://forms.cloud.microsoft/e/wbApA8XSg6?origin=lprLink",
      Link7: "https://forms.cloud.microsoft/e/PKg3Beefvf?origin=lprLink",
      Link8: "https://forms.cloud.microsoft/e/DV50WELQt6?origin=lprLink",
      Link9: "https://forms.cloud.microsoft/e/stmVBndzKw?origin=lprLink",
      Link10: "https://forms.cloud.microsoft/e/R3BEZj3SkC?origin=lprLink",
      Link11: "https://forms.cloud.microsoft/e/xzsapRgwhf?origin=lprLink",
      Link12: "https://forms.cloud.microsoft/e/adcdukN0R0?origin=lprLink",
      Link13: "https://forms.cloud.microsoft/e/jxFemTfGXU?origin=lprLink",
      Link14: "https://forms.cloud.microsoft/e/wtr3wq8JrV?origin=lprLink",
      Link15: "https://forms.cloud.microsoft/e/7wwQdS14LT?origin=lprLink",
      Link16: "https://forms.cloud.microsoft/e/JhfxcRUFa5?origin=lprLink",
      Link17: "https://forms.cloud.microsoft/e/0z4kr9qjj8?origin=lprLink",
      Link18: "https://forms.cloud.microsoft/e/8XeeVDqJY7?origin=lprLink",
      Link19: "https://forms.cloud.microsoft/e/JjuxmmWPUc?origin=lprLink",
      Link20: "https://forms.cloud.microsoft/e/xUX9V5vyBp?origin=lprLink",
      Link21: "",
      Link22: "",
      PDF1: "",
      PDF1a: "",
      PDF2: "",
      PDF2a: "",
      PDF3: "Security_Kapitel_3.pdf",
      PDF3a: "",
      PDF4: "Security_Kapitel_4.pdf",
      PDF4a: "",
      PDF5: "Security_Kapitel_5.pdf",
      PDF5a: "",
      PDF6: "Security_Kapitel_6.pdf",
      PDF6a: "",
      PDF7: "Security_Kapitel_7.pdf",
      PDF7a: "",
      PDF8: "Security_Kapitel_8.pdf",
      PDF8a: "",
      PDF9: "Security_Kapitel_9.pdf",
      PDF9a: "",
      PDF10: "Security_Kapitel_10.pdf",
      PDF10a: "",
      PDF11: "Security_Kapitel_11.pdf",
      PDF11a: "",
      PDF12: "Security_Kapitel_12.pdf",
      PDF12a: "",
      PDF13: "Security_Kapitel_13.pdf",
      PDF13a: "",
      PDF14: "Security_Kapitel_14.pdf",
      PDF14a: "",
      PDF15: "Security_Kapitel_15.pdf",
      PDF15a: "",
      PDF16: "Security_Kapitel_16.pdf",
      PDF16a: "",
      PDF17: "Security_Kapitel_17.pdf",
      PDF17a: "",
      PDF18: "Security_Kapitel_18.pdf",
      PDF18a: "",
      PDF19: "Security_Kapitel_19.pdf",
      PDF19a: "",
      PDF20: "Security_Kapitel_20.pdf",
      PDF20a: "",
      PDF21: "",
      PDF21a: "",
      PDF22: "TerminalFix_Berlin_IT-Unterricht.pdf",
      PDF22a: "",


      PDF_sonstige1: "",
      PDF_sonstige2: "",
      PDF_sonstige3: "",
      PDF_sonstige4: "",
      PDF_sonstige5: "",
      PDF_sonstige6: "",
      PDF_sonstige7: "",
      PDF_sonstige8: "",
      PDF_sonstige9: "",
      PDF_sonstige10: "",
      PDF_sonstige11: "",
      PDF_sonstige12: "",
      PDF_sonstige13: "",
      PDF_sonstige14: "",
      PDF_sonstige15: "",
      PDF_sonstige16: "",
      PDF_sonstige17: "",
      PDF_sonstige18: "",
      PDF_sonstige19: "",
      PDF_sonstige20: "",
      quiz90_1: "https://forms.cloud.microsoft/e/drLYN3enZi?origin=lprLink",
      quiz90_2: "https://forms.cloud.microsoft/e/vLSjbLtH8J?origin=lprLink",
      quiz90_3: "",
      quiz90_4: "",
      quiz90_5: "",
      quiz90_6: "",
      quiz90_7: "",
      quiz90_8: "",
      quiz90_9: "",
      quiz90_10: "",
    };
  },
  components: {},
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
